export const activitiesDir = '/data/activities';
export const plansDir = '/data/plans';
export const categoriesDir = '/data/categories';
export const codingPracticeDir = '/data/codingPractice';
export const projectDir = '/data/experience';
export const practiceDir = '/data/experience';
